import { render, staticRenderFns } from "./SettingUpdateModal.vue?vue&type=template&id=97fbdcb0&scoped=true&"
import script from "./SettingUpdateModal.vue?vue&type=script&lang=js&"
export * from "./SettingUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingUpdateModal.vue?vue&type=style&index=0&id=97fbdcb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fbdcb0",
  null
  
)

export default component.exports